import type { RootGroup } from 'types/shareable-channel'
export * from '@disco/state-management/selectors/groups'
/**
 * Gets the Root Group which is the parent of other groups in shared-channels
 */
export const getRootGroup = (state: any): RootGroup | null => state.rootGroup

/**
 * Returns the current folder information or the RootGroup's ID
 * if there is no current folderId and the RootGroup is present.
 */
export const getFolderOrRootId = (
  state: any,
  folder: {
    folderId?: string
    playlistId?: string
  },
): {
  folderId?: string
  playlistId?: string
} => {
  const rootGroup = getRootGroup(state)
  if (folder.folderId || !rootGroup) {
    return folder
  }
  return { folderId: String(rootGroup.id) }
}
